import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'anlagebuchhaltung',
  title: 'Anlagenbuchhaltung',
  description:
    'Anlagevermögen verwalten, Abschreibungen berechnen und Monatsabschlüsse nachvollziehbar vorbereiten.',
  icon: 'BookOpen',
  order: 140,
  apiBasePath: '/api/anlagebuchhaltung',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  // Leeres Array: für alle angemeldeten Nutzer sichtbar.
  // Sobald hier eine Rolle steht, sehen nur Nutzer mit dieser Rolle das Modul.
  roles: [
    'anlagebuchhaltung.buchhaltung',
    'anlagebuchhaltung.leitung',
    'anlagebuchhaltung.admin',
  ],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
